export default {
	USER_CREATED: 'User Created',
	ACTIVITY_LIBRARY: 'Activity Library',
}
